import React, { useState } from 'react';
import './SolutionsSection.css';

const solutions = [
  {
    id: 1,
    icon: '/phone-icon.svg',
    name: 'Intelligent Voice Agent (IVA)',
    description: 'Conversational AI that handles rider inquiries 24/7'
  },
  {
    id: 3,
    icon: '/brain-icon.svg',
    name: 'Transit AI Suite',
    description: 'Comprehensive analytics and optimization platform'
  },
  {
    id: 4,
    icon: '/people-icon.svg',
    name: 'Rider Eligibility Automation',
    description: 'Streamlined eligibility verification process'
  },
  {
    id: 5,
    icon: '/workforce-icon.svg',
    name: 'Workforce Management',
    description: 'Intelligent scheduling and operations management'
  },
  {
    id: 6,
    icon: '/wrench-star-icon.svg',
    name: 'Predictive Maintenance',
    description: 'AI-driven vehicle health monitoring'
  }
];

const SolutionsSection = () => {
  const [expandedTile, setExpandedTile] = useState(null);

  const handleTileExpand = (id) => {
    setExpandedTile(expandedTile === id ? null : id);
  };

  return (
    <div className="solutions-section-wrapper">
      <div className="solutions-section-container">
        <div className="solutions-header">
          <div className="solutions-title-container">
            <img src="/sparkle.png" alt="sparkle" className="sparkle-icon-solutions" />
            <span>AI-POWERED TOOLS</span>
          </div>
          <h1>Complete Transit Technology Suite</h1>
          <p className="solutions-subtitle">Five powerful AI tools designed to transform every aspect of your transit operations.</p>
          <p className="solutions-cta">Click any tool to learn more.</p>
        </div>
        <div className="solutions-grid">
          {solutions.map((solution) => (
            <div
              key={solution.id}
              className={`solution-card ${expandedTile !== null ? 'expanded-state' : ''}`}
              onClick={() => handleTileExpand(solution.id)}
              style={{ cursor: 'pointer' }}
            >
              <div className="card-header">
                <div className="card-icon">
                  <img src={solution.icon} alt="icon" />
                </div>
                <div className="expand-button">
                  {expandedTile === solution.id ? (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 10L8 6L12 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
              </div>
              <h3>{solution.name}</h3>
              <p>{solution.description}</p>
              {expandedTile === solution.id && (
                <div className="card-paragraphs">
                  <p>Detailed information about {solution.name} would appear here when expanded.</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SolutionsSection;
